<template>
	<div class="business-index">
		<Search :renderData="renderData" :formData="queryForm" @onSearch="onSearch"></Search>
		<div class="fun-btn-box">
			<auth-button auth="mall:description:create">
				<el-button type="primary" class="fun-btn mr10" @click="onAdd">+ 添加核销账户</el-button>
			</auth-button>
		</div>
		<Table :tableThData="tableThData" :tableTrData="tableTrData" :loading="loading" :limit="limit" :total="total"
			:offset="offset" v-on:handleSizeChange="handleSizeChange" v-on:handleCurrentChange="handleCurrentChange">
			<template #name="{ row }">{{ row.name }}</template>
			<template #mallName="{ row }">{{ row.mallName }}</template>
			<template #storeName="{ row }">{{ row.storeName }}</template>
			<template #passWord="{ row }">{{ row.passWord }}</template>
			<template
				#created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
			<template #operatorName="{ row }">{{ row.operatorName }}</template>
			<template #operation="{ scope }">
				<!-- <auth-button auth="mall:description:update">
					<el-button class="mr10" type="text" @click="onEdit(scope.row)">编辑</el-button>
				</auth-button> -->
				<auth-button auth="mall:description:update">
					<el-button class="mr10" type="text" @click="onChangePassword(scope.row)">修改密码</el-button>
				</auth-button>
				<auth-button auth="mall:description:delete">
					<el-button class="del" type="text" @click="onDelete(scope.row)">删除</el-button>
				</auth-button>
			</template>
		</Table>
		<el-dialog title="修改密码" :visible.sync="changePwdVisible">
			<el-form :model="form">
				<el-form-item label="密码">
					<el-input v-model="password" autocomplete="off" show-password></el-input>
				</el-form-item>
				<el-form-item label="确认密码">
					<el-input v-model="confirmPassword" autocomplete="off" show-password></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="changePwdVisible = false">取 消</el-button>
				<el-button type="primary" @click="onSubmit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import AuthButton from '@/components/AuthButton'
	import tableList from '@/mixins/tableList'
	import Search from "@/components/Search/index"
	import {
		getList,
		del,
		update
	} from '@/api/writeoffAccount'
	import Table from "@/components/Table/index";
	export default {
		name: "marketCouponListIndex",
		mixins: [tableList],
		components: {
			AuthButton,
			Table,
			Search,
		},
		data() {
			return {
				changePwdVisible: false,
				queryForm: {},
				renderData: [{
						label: "用户名",
						placeholder: "请输入用户名",
						type: "input",
						multiple: false,
						key: "name"
					},
					{
						label: "店铺",
						placeholder: "请选择店铺",
						type: "choose-store-single",
						multiple: true,
						key: "storeIds"
					},
				],
				form: {},
				query: {
					offset: 0,
					limit: 10,
					name: ''
				},
				editRow: null,
				password: '',
				confirmPassword: '',
				tableThData: [{
						prop: "mallName",
						label: "商场",
						minWidth: "180",
					},
					{
						prop: "storeName",
						label: "店铺",
						minWidth: "180",
					},
					{
						prop: "name",
						label: "账户名称",
						minWidth: "180",
					},
					{
						prop: "passWord",
						label: "密码",
						minWidth: "180",
					},
					{
						prop: "operation",
						label: "操作",
						minWidth: "100",
					},
				],
			};
		},
		created() {},
		methods: {
			// 获取表格列表数据
			async getList() {
				console.log('当前查询表单：',this.queryForm)
				this.loading = true
				if(this.form.storeIds){
					this.form.storeIds = [this.form.storeIds]
				}
				const params = {
					...this.form,
					offset: this.offset,
					limit: this.limit,
				}
				this.$router.push({
					query: params
				})
				const data = await getList(params)
				console.log('data: ', data);
				this.tableTrData = data.list || []
				this.total = data.count
				this.loading = false
			},
			// 点击创建按钮
			onAdd() {
				this.$router.push({
					path: "/serverConfig/writeoffAccount/add"
				})
			},
			onDelete(row) {
				console.log('当前删除记录：', row)
				this.$baseConfirm(
					'是否删除该账户？', {
						title: '提示',
						type: 'warning',
					},
					async () => {
						await del({
							id: row.id
						})
						this.$baseMessage('操作成功', 'success')
						this.getList()
					}
				)
			},
			onEdit(row) {
				this.$router.push({
					path: "/serverConfig/writeoffAccount/add?id=" + row.id
				})
			},
			onChangePassword(row) {
				this.changePwdVisible = true;
				this.editRow = row;
			},
			onSubmit() {

				if (!this.password) {
					this.$baseMessage('请输入密码', 'error');
					return;
				}
				if (this.password != this.confirmPassword) {
					this.$baseMessage('两次密码不一致', 'error');
					return;
				}

				update({
					id: this.editRow.id,
					passWord: this.password
				}).then(_ => {
					if (_ == 'success') {
						this.$baseMessage('操作成功', 'success')
						this.changePwdVisible = false;
					} else {
						this.$baseMessage('操作失败，请重试', 'error')
					}
				})
			}
		},
		watch: {},
		computed: {},
	};
</script>
<style lang="scss" scoped>
	.business-index {
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;

		.fun-btn-box {
			margin-top: 20px;
		}

		.del {
			color: #F74A4A;
		}

		::v-deep {

			// 去除switch禁用 css
			.el-switch.is-disabled {
				opacity: 1;
			}

			.el-switch.is-disabled .el-switch__core,
			.el-switch.is-disabled .el-switch__label {
				cursor: pointer;
			}
		}

		.image {
			width: 120px;
			height: 56px;
			object-fit: fill;
			object-fit: contain;
			object-fit: cover;
			object-fit: none;
			object-fit: scale-down;
		}
	}
</style>